import React, { useEffect } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { MyloadTiles } from "../../../web/components/myloads";
import { getCount, makeMyLoadCardData } from "../../../selectors/Myload/selector";
import { MyLoadsPage } from "../../../web/pages/MyLoads";
import { fetchShipments } from "../../../actions/carrierAssign/action";
import { IONICWrapper, isEntitled } from "../../../utils/common";
import { getUserMasterData } from "../../../selectors/selector";
import { MyLoad } from "../../../models/myLoad/myLoad";
import { useHistory } from "react-router";
import { FetchFromMyLoadConfig } from "../../../utils/MyLoads.util";

const MyLoadsContainer: React.FC<any> = (props: any) => {
  const { isHome = false, history, count } = props;
  const __history = useHistory();
  const userPrincipalName: string =
    (props.userDetails?.memberDetailsResponse?.member?.upn) || "";
  const myLoadsMaxPageSize = FetchFromMyLoadConfig("PageSize");
  useEffect(() => {
    if (
      userPrincipalName &&
      history.location.state &&
      !(history.location.state.callExistingAPI === false) &&
      __history.location.pathname == "/app/home"
    ) {
      const isDriver = !isEntitled("myLoad", "carrierAssigned");
      const _model: MyLoad = new MyLoad();
      if (isDriver) {
        _model.driverId = userPrincipalName;
      }
      _model.filter = {
        carrierTendered: true,
        carrierAssigned: isEntitled("myLoad", "carrierAssigned"),
        driverAssigned: true,
        inTransit: true,
        deliveredNeedsPaperWork: true,
        deliveredWithPaperWork: true
      };
      _model.pagination = {
        pageSize: myLoadsMaxPageSize,
        pageIndex: 0,
       // myLoadPageFilter: null
      }
      props.fetchMyloads(_model.getMyLoadCount());
    }
  }, [userPrincipalName]);

  return isHome ? <MyloadTiles {...props} /> : <MyLoadsPage {...props} />;
};

const mapStateToProps = createStructuredSelector({
  count: getCount(),
  tiles: makeMyLoadCardData(),
  userDetails: getUserMasterData(),
});

export const mapDispatchToProps = (dispatch: Function) => ({
  fetchMyloads: (details: any) => dispatch(fetchShipments(details, false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyLoadsContainer);
